import {LOCALES} from './locales'

export const messages = {
    [LOCALES.ENGLISH]: {
        Candidate: 'Candidate',
        Vacancy: 'Vacancy',
        Client: 'Client',
        Employee: 'Employee',
        General: 'General',
        Send: 'Send',
        "Select file": 'Select file',
        "Request preview": 'Request preview',
        "Go to CleverStaff": "Go to CleverStaff",
        "Field type": "Field type",
        "Field name": "Field name",
        Description: "Description",
        "candidateId": "candidate id",
        "vacancyId": "vacancy id",
        "orgId": "account id",
        "localId": "short id",
        "fullName": "full name",
        "firstName": "first name",
        "lastName": "last name",
        "currentPosition": "current position",
        "position": "desired position",
        "currentWorkPlace": "current work place",
        "employmentType": "employment type",
        "industry": "industry",
        "currency": "currency",
        "expirence": "experience",
        "coreSkills": "core skills",
        "db": "date of birth",
        "sex": "sex (true - male, false - female)",
        "salary": "salary",
        "status": "status",
        "dm": "edit date",
        "dc": "creation date",
        "creatorId": "creator id",
        "responsibleId": "responsible id",
        "descr": "description",
        "readyRelocate": "is ready to relocate",
        "regionId": "region id",
        "relocatedRegionIds": "region ids to relocate",
        "origin": "origin",
        "region": "region",
        "relatedRegions": "regions to relocate",
        "contacts": "contacts",
        "skills": "skills",
        "customFields": "custom fields",
        "languages": "languages",
        "containsWord": "true - search by part of a word, false - by the whole word",
        "words": "words to search",
        "candidateGroupIds": "tag ids",
        "city": "city",
        "country": "country",
        "dateFrom": "start date",
        "dateTo": "end date",
        "experience": "experience",
        "sort": "sort by",
        "sortOrder": "sort order (ASC/DESC)",
        "state": "state",
        "page": "page",
        "interviews": "array of interview objects",
        "candidateState": "candidate state",
        "comment": "comment",
        "clientId": "client id",
        "dateFinish": "vacancy finish date",
        "fieldValues": "custom fields",
        "numberOfPositions": "vacancy number of position",
        "salaryFrom": "start salary from",
        "salaryTo": "end salary to",
        "accessType": "vacancy access type for users",
        "interviewStatus": "status of interview",
        "vacanciesForCandidatesAccess": "vacancy access type for candidates",
        "hideSalary": "to hide salary",
        "responsibles": "array of responsible objects",
        "actions": "array of action objects",
        "person": "user",
        "client": "client",
        "creator": "creator",
        "responsiblesPerson": "array of responsible objects",
        "responsible": "responsible",
        "testIds": "ids of tests",
        "total": "total objects after search",
        "number": "number of current page",
        "size": "size per page",
        "limitReached": "is limit reached",
        "allPageCount": "total page count",
        "objName": "type of entity",
        "objId": "id of entity",
        "type": "type",
        "recrutRole": "user role in account",
        "personId": "user id",
        "userId": "user id",
        "phone": "phone",
        "date": "date",
        "area": "area",
        "googlePlaceId": "id from google maps",
        "fromGoogle": "is added from google",
        "title": "title",
        "contactClientList": "array of contacts related to client",
        "contactClientId": "id of contact related to client",
        "lat": "latitude",
        "lng": "longitude",
        "clientState": "state of client",
        "objectType": "type of entity",
        "fieldId": "id of field",
        "fullEmployment": "Full time",
        "underemployment": "Part time",
        "remote": "Remote",
        "trainingAndPractice": "Training, practice",
        "projectWork": "Project",
        "relocate": "Relocate",
        "temporaryWork": "Temporary",
        "combined": "Combined",
        "shiftWork": "Shift work/rotational shift work",
        "e00_no_experience": "Experience not specified",
        "e01_less_than1year": "Less than 1 year",
        "e1_1year": "1 year",
        "e2_2years": "2 years",
        "e3_3years": "3 years",
        "e4_4years": "4 years",
        "e5_5years": "5+ years",
        "e6_10years": "10+ years",
        USD: "US dollar",
        EUR: "euro",
        UAH: "hryvnia",
        RUB: "ruble",
        ARS: "Argentine peso",
        AUD: "Australian dollar",
        BRL: "Brazilian real",
        BYN: "Belarusian ruble",
        CAD: "Canadian dollar",
        CNY: "Chinese yuan",
        GBP: "pounds sterling",
        HKD: "Hong Kong dollar",
        IDR: "Indonesian rupiah",
        INR: "Indian rupee",
        JPY: "Japanese yen",
        KZT: "Kazakh tenge",
        LKR: "Sri Lankan rupee",
        MXN: "Mexican peso",
        MYR: "Malaysian ringgit",
        PHP: "Philippine peso",
        PLN: "Polish zloty",
        RMB: "Chinese Yuan",
        SGD: "Singapore dollar",
        THB: "Thai baht",
        ZAR: "South African rand",
        KRW: "South Korean won",
        EGP: "Egyptian functions",
        UZS: "Uzbek soum",
        KGS: "Kyrgyz som",
        MDL: "Moldovan lei",
        AZN: "Azerbaijanian manat",
        RON: "Romanian leu",
        COP: "Columbian peso",
        GEL: "Georgian lari",
        AMD: "Armenian dram",
        CZK: "Czech koruna",
        add_manually: "manually",
        add_from_recommendation: "from recommendation",
        add_from_email: "from mail",
        add_from_recall: "from feedback",
        add_from_linkedinNew: "from linkedin",
        add_from_hh: "from headHunter",
        add_from_workua: "from workua",
        add_from_rabotaua: "from rabotaua",
        add_from_superjob: "from superjob",
        add_from_djinni: "from djinni",
        add_from_cvlv: "from cvlv",
        add_from_jobstutby: "from jobstutby",
        add_from_jobkg: "from jobkg",
        add_from_google_drive: "from google drive",
        add_from_rabotauz: "from google rabotauz",
        add_from_dou: "from google dou",
        add_from_excel: "from google excel",
        add_from_archive: "from google archive",
        add_from_grc: "from grc",
        relevance: "relevance",
        lastCommentDate: "last comment date",
        hireDate: "hire date",
        alphabetically: "alphabetically",
        priority: "priority",
        clientName: "client name",
        scoreCard: "score",
        gdpr: "gdpr status",
        ASC: "by ascending",
        DESC: "by descending",
        private: "private",
        public: "public",
        in_process: "in_process",
        rejects: "rejected",
        accept: "accepted",
        vacancy: "vacancy",
        candidate: "candidate",
        task: "task",
        candidate_attachment: "candidate attachment",
        client_attachment: "client attachment",
        vacancy_attachment: "vacancy attachment",
        avatar: "avatar",
        vacancy_application: "vacancy application",
        "future": "Future",
        "in_work": "In Progress",
        "on_hold": "On hold",
        "all_done": "All Done",
        "deleted": "Deleted",
        "canceled": "Canceled",
        Objects: "Objects",
        Api: "Api",
        Fields: "Fields",
        Dictionary: "Dictionary",
        "POST/api/v3/candidates/interviewsdescr": "Adding a candidate for a job",
        "GET/api/v3/candidates/originsdescr": "Getting candidate add origin fields",
        "GET/api/v3/candidates/languagesdescr": "Getting a list of all candidate languages",
        "POST/api/v3/candidates/file/namedescr": "Editing link to candidate resume",
        "DELETE/api/v3/candidates/filedescr": "Delete link to candidate resume",
        "POST/api/v3/candidates/searchdescr": "Search candidates",
        "GET/api/v3/candidatesdescr": "Getting one candidate",
        "POST/api/v3/candidates/linkdescr": "Adding link to candidate resume",
        "POST/api/v3/candidatesdescr": "Adding candidates",
        "POST/api/v3/candidates/statesdescr": "Change candidate status",
        "GET/api/v3/vacanciesdescr": "Getting one vacancy",
        "POST/api/v3/vacanciesdescr": "Adding vacancies",
        "POST/api/v3/vacancies/searchdescr": "Search vacancies",
        "GET/api/v3/vacancies/interviewsdescr": "Getting all added job candidates",
        "GET/api/v3/vacancies/actionsdescr": "Getting all actions on a vacancy",
        "GET/api/v3/clientsdescr": "Getting one customer",
        "POST/api/v3/clients/responsiblesdescr": "Change responsible customer",
        "PUT/api/v3/clientsdescr": "Edit client",
        "POST/api/v3/clients/statesdescr": "Customer status change",
        "POST/api/v3/clientsdescr": "Adding client",
        "POST/api/v3/clients/searchdescr": "Search for customers",
        "DELETE/api/v3/clients/responsiblesdescr": "Delete responsible customer",
        "GET/api/v3/employees/fireddescr": "Getting fired employees",
        "GET/api/v3/employees/newdescr": "Get new employees",
        "GET/api/v3/regionsdescr": "Get list of regions",
        "GET/api/v3/filesdescr": "Download file",
        "GET/api/v3/cities/autocompletedescr": "Get list of cities",
        "GET/api/v3/scoreCardsdescr": "Getting ScoreCards",
        "POST/api/v3/filesdescr": "Adding file",
        "GET/api/v3/usersdescr": "Getting a list of all users",
        "GET/api/v3/countriesdescr": "Getting list of countries",
        "GET/api/v3/customFieldsdescr": "Get custom fields",
        "GET/api/v3/state/actionsdescr": "Get vacancy change state actions. 'dateFrom' and 'dateTo' require format 'yyyy-MM-dd', default page value is 0",
        "GET/api/v3/customStatesdescr": "Get custom states",
        "GET/api/v3/interview/actionsdescr": "Get interview actions. 'dateFrom' and 'dateTo' require format 'yyyy-MM-dd', default page value is 0",
        "GET/api/v3/downloaddescr": "Download file from url",
        active_search: "Active search",
        archived: "Archived",
        black_list: "Black List",
        employed: "Employed",
        freelancer: "Freelancer",
        not_searching: "Not interested",
        only_relocation_abroad: "Relocation only",
        only_remote: "Remote only",
        passive_search: "Passive search",
        reserved: "In reserve",
        work: "Our employee",
        "candidate_add": "candidate added",
        "candidate_add_manually": "candidate added manually",
        "candidate_add_from_linkedin": "candidate added from linkedin",
        "candidate_add_from_workua": "candidate added from work.ua",
        "candidate_add_from_email": "candidate added from email",
        "candidate_add_from_rabotaua": "candidate added from robota.ua",
        "candidate_add_from_archive": "candidate added from archive",
        "candidate_add_from_excel": "candidate added from excel",
        "candidate_add_from_hh": "candidate added from hh",
        "candidate_add_from_djinni": "candidate added from djinni",
        "candidate_update_from_excel": "candidate updated from excel",
        "candidate_update_from_file": "candidate updated from file",
        "candidate_update_from_workua": "candidate updated from work.ua",
        "candidate_update_from_archive": "candidate updated from archive",
        "candidate_update_from_rabotaua": "candidate updated from robota.ua",
        "candidate_update_from_linkedinNew": "candidate updated from linkedin",
        "candidate_edit": "candidate edited",
        "candidate_edit_from_email": "candidate edited from email",
        "candidate_edit_contacts": "candidate contacts edited",
        "candidate_add_file": "added file to candidate",
        "candidate_add_to_group": "tag added to candidate",
        "candidate_message": "comment added to candidate",
        "candidate_change_state": "change of candidate status",
        "candidate_set_responsible": "added responsible to candidate",
        "candidate_message_for_hm": "added comment to candidate for recruiter",
        "candidate_sent_email": "email sent to candidate",
        "candidate_edit_group": "edited tag",
        "candidate_remove_from_group": "removed tag",
        "candidate_edit_pdcs": "change of personal data status",
        "interview_add": "interview added",
        "interview_add_from_rabotaUa": "interview added from robota.ua",
        "interview_add_from_workUa": "interview added from work.ua",
        "interview_edit": "interview edited",
        "interview_message": "interview comment added",
        "interview_remove": "interview removed",
        "task_create": "task created",
        "task_change_status": "task status changed",
        "vacancy_change_state": "vacancy status changed",
        "vacancy_add": "vacancy added",
        "vacancy_edit": "vacancy edited",
        "vacancy_set_responsible": "vacancy responsible added",
        "interview": "Interview",
        "applied_people": "Applied People",
        "shortlist": "Short List",
        "longlist": "Long List",
        "notafit": "Not a Fit",
        "declinedoffer": "Refused",
        "offer_declined": "Offer declined",
        "probation_failure": "Fail of probation",
        "is_not_looking_for_job": "Is not looking for a job",
        "approved": "Hired",
        "interview_with_the_boss": "Interview with the Boss",
        "tech_interview": "Tech Interview",
        "hr_interview": "HR Interview",
        "interview_with_the_client": "Customer Interview",
        "job_offer": "Job Offer",
        "test_task": "Test Task",
        "security_check": "Security Check",
        "tech_screen": "Tech Screen",
        "sent_offer": "Offer Sent",
        "accept_offer": "Offer Accepted",
        "invite_to_interview": "Invite to interview",
        "interview_scheduled": "Interview Scheduled",
        "interview_conducted": "Interview conducted",
        "rejected": "Rejected",
        "no_response": "Not responding",
        "no_contacts": "No contacts",
        "accepted_counter_offer": "Accepted counter offer",
        "found_another_job": "Found another job",
        "open": "Open",
        "disqualified": "Disqualified",
    },
    [LOCALES.UKRAINIAN]: {
        Candidate: 'Кандидати',
        Vacancy: 'Вакансії',
        Client: 'Замовники',
        Employee: 'Співробітники',
        General: 'Загальне',
        Send: 'Надіслати',
        "Request preview": 'Попередній перегляд',
        "Go to CleverStaff": "Перейти к CleverStaff",
        "Field type": "Тип поля",
        "Field name": "Назва поля",
        Description: "Опис",
        "candidateId": "id кандидата",
        "vacancyId": "id вакансії",
        "orgId": "id акаунта",
        "localId": "id скорочений",
        "fullName": "ПІБ",
        "firstName": "ім'я",
        "lastName": "прізвище",
        "Select file": 'Обрати файл',
        "currentPosition": "теперішня посада",
        "position": "бажана посада",
        "currentWorkPlace": "теперішнє місце роботи",
        "employmentType": "тип зайнятості",
        "industry": "сфера",
        "currency": "валюта",
        "expirence": "досвід",
        "coreSkills": "основні навички",
        "db": "дата народження",
        "sex": "стать (true - чоловіча, false - жіноча)",
        "salary": "зарплатня",
        "status": "статус",
        "dm": "дата редагування",
        "dc": "дата створення",
        "creatorId": "id творця",
        "responsibleId": "id відповідального",
        "descr": "опис",
        "readyRelocate": "чи готов до переїзду",
        "regionId": "id регіону",
        "relocatedRegionIds": "id регіонів для переїзду",
        "origin": "джерело",
        "region": "регіон",
        "relatedRegions": "регіон для переїзду",
        "contacts": "контаки",
        "skills": "навички",
        "customFields": "поля, що налаштовуються",
        "languages": "мови",
        "containsWord": "true - пошук за частиною слова, false - по цілому слову",
        "words": "слово для пошуку",
        "candidateGroupIds": "id тегів",
        "city": "місто",
        "country": "країна",
        "dateFrom": "початкова дата",
        "dateTo": "кінцева дата",
        "experience": "досвід",
        "sort": "сортування за",
        "sortOrder": "порядок сортування (ASC/DESC)",
        "state": "стан",
        "page": "сторінка",
        "interviews": "масив об'єктів interview",
        "candidateState": "статус кандидата",
        "comment": "коментар",
        "clientId": "id замовник",
        "dateFinish": "дата закінчення вакансии",
        "fieldValues": "налаштовувані поля",
        "numberOfPositions": "кількість позицій вакансії",
        "salaryFrom": "нижня межа зарплатні",
        "salaryTo": "верхня межа зарплатні",
        "accessType": "тип доступу вакансії для користувачів",
        "interviewStatus": "статус співбесіди",
        "vacanciesForCandidatesAccess": "тип доступу вакансії для для кандидатів",
        "hideSalary": "приховувати зарплатню",
        "responsibles": "масив об'єктів responsible",
        "actions": "масив об'єктів action",
        "person": "користувач",
        "client": "замовник",
        "creator": "творець",
        "responsiblesPerson": "масив responsible объектов",
        "responsible": "відповідальний",
        "testIds": "id тестів",
        "total": "всього об'єктів",
        "number": "номер поточної сторінки",
        "size": "кількість об'єктів на сторінці",
        "limitReached": "чи досягнута межа",
        "allPageCount": "всього сторінок",
        "objName": "тип сутності",
        "objId": "id сутності",
        "type": "тип",
        "recrutRole": "роль користувача в акаунті",
        "personId": "id користувача",
        "userId": "id користувача",
        "phone": "телефон",
        "date": "дата",
        "area": "область/регіон",
        "googlePlaceId": "id з google maps",
        "fromGoogle": "додан з гуглу",
        "title": "назва",
        "contactClientList": "масив contacts замовника",
        "contactClientId": "id контакта замовника",
        "lat": "широта",
        "lng": "довгота",
        "clientState": "статус замовника",
        "objectType": "тип сутності",
        "fieldId": "id поля",
        "fullEmployment": "Повна зайнятість",
        "underemployment": "Часткова зайнятість",
        "remote": "Віддалена робота",
        "trainingAndPractice": "Навчання, практика",
        "projectWork": "Проектні роботи",
        "relocate": "Переїзд",
        "temporaryWork": "Сезонна, тимчасова робота",
        "combined": "Комбінований",
        "shiftWork": "Позмінна робота/вахтовий метод",
        "e00_no_experience": "Досвід не вказано",
        "e01_less_than1year": "Менше року",
        "e1_1year": "1 рік",
        "e2_2years": "2 роки",
        "e3_3years": "3 роки",
        "e4_4years": "4 роки",
        "e5_5years": "5+ років",
        "e6_10years": "10+ років",
        USD: "долар США",
        EUR: "євро",
        UAH: "гривня",
        RUB: "рубль",
        ARS: "аргентинське песо",
        AUD: "австралійський долар",
        BRL: "бразильський реал",
        BYN: "білоруський рубль",
        CAD: "канадський долар",
        CNY: "китайський юань",
        GBP: "фунт стерлінгів",
        HKD: "гонгконський долар",
        IDR: "індонезійська рупія",
        INR: "індійська рупія",
        JPY: "японська ієна",
        KZT: "казахтанський тенге",
        LKR: "шрі - ланкійська рупія",
        MXN: "мексиканське песо",
        MYR: "малазійський рінггіт",
        PHP: "філіппінське песо",
        PLN: "польський злотий",
        RMB: "китайський юань",
        SGD: "сінгапурський долар",
        THB: "тайський бат",
        ZAR: "південноафриканський ренд",
        KRW: "південнокорейська вона",
        EGP: "єгипетський функцій",
        UZS: "узбецький сум",
        KGS: "киргизький сом",
        MDL: "молдавський лей",
        AZN: "азейбарджанський манат",
        RON: "румунський лей",
        COP: "колумбійський песо",
        GEL: "грузинський ларі",
        AMD: "вірменський драм",
        CZK: "чеська крона",
        add_manually: "вручну",
        add_from_recommendation: "з рекомендації",
        add_from_email: "з пошти",
        add_from_recall: "з відгуку",
        add_from_linkedinNew: "з linkedin",
        add_from_hh: "з headHunter",
        add_from_workua: "з workua",
        add_from_rabotaua: "з rabotaua",
        add_from_superjob: "з superjob",
        add_from_djinni: "з djinni",
        add_from_cvlv: "з cvlv",
        add_from_jobstutby: "з jobstutby",
        add_from_jobkg: "з jobkg",
        add_from_google_drive: "з google drive",
        add_from_rabotauz: "з rabotauz",
        add_from_dou: "з dou",
        add_from_excel: "з excel",
        add_from_archive: "з архіву",
        add_from_grc: "з grc",
        relevance: "релевантність",
        lastCommentDate: "дата останнього коментаря",
        hireDate: "дата найму",
        alphabetically: "по алфавіту",
        priority: "приорітет",
        clientName: "ім'я замовника",
        scoreCard: "оцінка",
        gdpr: "gdpr статус",
        ASC: "за зростянням",
        DESC: "за спаданням",
        private: "прихований",
        public: "загальнодуступний",
        in_process: "поточне",
        rejects: "відмовився",
        accept: "приняв",
        candidate: "кандидат",
        task: "задача",
        vacancy: "вакансія",
        candidate_attachment: "вкладення кандидата",
        client_attachment: "вкладення замовника",
        vacancy_attachment: "вкладення вакансії",
        avatar: "світлина",
        vacancy_application: "заявка на вакансію",
        "future": "Майбутній",
        "in_work": "В роботі",
        "on_hold": "Призупинений",
        "all_done": "Робота завершена",
        "deleted": "Видалений",
        "canceled": "Скасований",
        Objects: "Об'єкти",
        Api: "Апі",
        Fields: "Поля",
        Dictionary: "Словник",
        "POST/api/v3/candidates/interviewsdescr": "Додавання кандидата на вакансію",
        "GET/api/v3/candidates/originsdescr": "Отримання полів джерел додавання кандидата",
        "GET/api/v3/candidates/languagesdescr": "Отримання списку всіх мов кандидатів",
        "POST/api/v3/candidates/file/namedescr": "Редагування посилання на резюме кандидата",
        "DELETE/api/v3/candidates/filedescr": "Видалення посилання на резюме кандидата",
        "POST/api/v3/candidates/searchdescr": "Пошук кандидатів",
        "GET/api/v3/candidatesdescr": "Отримання одного кандидата",
        "POST/api/v3/candidates/linkdescr": "Додавання посилання на резюме кандидата",
        "POST/api/v3/candidatesdescr": "Додавання кандидатів",
        "POST/api/v3/candidates/statesdescr": "Зміна статусу кандидата",
        "GET/api/v3/vacanciesdescr": "Отримання однієї вакансії",
        "POST/api/v3/vacanciesdescr": "Додавання вакансії",
        "POST/api/v3/vacancies/searchdescr": "Пошук вакансій",
        "GET/api/v3/vacancies/interviewsdescr": "Отримання всіх доданих кандидатів по вакансії",
        "GET/api/v3/vacancies/actionsdescr": "Отримання всіх дій по вакансії",
        "GET/api/v3/clientsdescr": "Отримання одного замовника",
        "POST/api/v3/clients/responsiblesdescr": "Зміна відповідального замовника",
        "PUT/api/v3/clientsdescr": "Редагування замовника",
        "POST/api/v3/clients/statesdescr": "Зміна статусу замовника",
        "POST/api/v3/clientsdescr": "Додавання замовника",
        "POST/api/v3/clients/searchdescr": "Пошук замовників",
        "DELETE/api/v3/clients/responsiblesdescr": "Видалити відповідального замовника",
        "GET/api/v3/employees/fireddescr": "Отримання звільненних співробітників",
        "GET/api/v3/employees/newdescr": "Отримання нових співробітників",
        "GET/api/v3/regionsdescr": "Отримання списку регіонів",
        "GET/api/v3/filesdescr": "Завантаження файлу",
        "GET/api/v3/cities/autocompletedescr": "Отримання списку міст",
        "GET/api/v3/scoreCardsdescr": "Отримання карт оцінок",
        "POST/api/v3/filesdescr": "Додавання файлу",
        "GET/api/v3/usersdescr": "Отримання списку всіх користувачів",
        "GET/api/v3/countriesdescr": "Отримання списку країн",
        "GET/api/v3/customFieldsdescr": "Отримання полів, що налаштовуються",
        "GET/api/v3/state/actionsdescr": "Отримання дій за зміною статуса вакансії. 'dateFrom' та 'dateTo' мають бути у форматі 'yyyy-MM-dd', значення за змовчування page value = 0",
        "GET/api/v3/customStatesdescr": "Отримання кастомних етапів",
        "GET/api/v3/interview/actionsdescr": "Отримання дій за співбесідами. 'dateFrom' та 'dateTo' мають бути у форматі 'yyyy-MM-dd', значення за змовчування page value = 0",
        "GET/api/v3/downloaddescr": "Завантажити файл за посиланням",
        active_search: "Активний пошук",
        archived: "Архівований",
        black_list: "Чорний список",
        employed: "Найнятий",
        freelancer: "Фрілансер",
        not_searching: "Не зацікавлений",
        only_relocation_abroad: "Тільки переїзд",
        only_remote: "Тільки віддалено",
        passive_search: "Пасивний пошук",
        reserved: "В резерві",
        work: "Наш співробітник",
        "candidate_add": "доданий кандидат",
        "candidate_add_manually": "кандидат доданий вручну",
        "candidate_add_from_linkedin": "кандидат доданий з linkedin",
        "candidate_add_from_workua": "кандидат доданий з work.ua",
        "candidate_add_from_email": "кандидат доданий з пошти",
        "candidate_add_from_rabotaua": "кандидат доданий з robota.ua",
        "candidate_add_from_archive": "кандидат доданий з архіву",
        "candidate_add_from_excel": "кандидат доданий з excel",
        "candidate_add_from_hh": "кандидат доданий з hh",
        "candidate_add_from_djinni": "кандидат доданий з djinni",
        "candidate_update_from_excel": "кандидат оновлений з excel",
        "candidate_update_from_file": "кандидат оновлений з файлу",
        "candidate_update_from_workua": "кандидат оновлений з work.ua",
        "candidate_update_from_archive": "кандидат оновлений з архіву",
        "candidate_update_from_rabotaua": "кандидат оновлений з robota.ua",
        "candidate_update_from_linkedinNew": "кандидат оновлений з linkedin",
        "candidate_edit": "кандидат відредагований",
        "candidate_edit_from_email": "кандидат відредагований з пошти",
        "candidate_edit_contacts": "контакти кандидата відредаговані",
        "candidate_add_file": "доданий файл до кандидата",
        "candidate_add_to_group": "доданий тег до кандидата",
        "candidate_message": "доданий коментар до кандидата",
        "candidate_change_state": "зміна статусу кандидата",
        "candidate_set_responsible": "доданий відповідальний до кандидата",
        "candidate_message_for_hm": "доданий коментар до кандидата для рекрутера",
        "candidate_sent_email": "лист відправлений кандидату",
        "candidate_edit_group": "відредагований тег",
        "candidate_remove_from_group": "відалений тег",
        "candidate_edit_pdcs": "зміна статусу персональних даних",
        "interview_add": "додана співбесіда",
        "interview_add_from_rabotaUa": "співбесіда додана з robota.ua",
        "interview_add_from_workUa": "співбесіда додана з work.ua",
        "interview_edit": "співбесіда відредагована",
        "interview_message": "доданий коментар до співбесіди",
        "interview_remove": "співбесіда видалена",
        "task_create": "завдання створене",
        "task_change_status": "статус завдання змінений",
        "vacancy_change_state": "статус вакансії змінений",
        "vacancy_add": "вакансія додана",
        "vacancy_edit": "вакансія відредагована",
        "vacancy_set_responsible": "доданий відповідальний по вакансії",
        "interview": "Співбесіда",
        "applied_people": "Відгуки",
        "shortlist": "Відібрані",
        "longlist": "Знайдені",
        "notafit": "Не підходить",
        "declinedoffer": "Відмовився",
        "offer_declined": "Відмовився від оффера",
        "probation_failure": "Провалений випробувальний термін",
        "is_not_looking_for_job": "Пошук роботи не актуальний",
        "approved": "Вийшов на роботу",
        "interview_with_the_boss": "Співбесіда з керівником",
        "tech_interview": "Тех. співбесіда",
        "hr_interview": "HR співбесіда",
        "interview_with_the_client": "Співбесіда з замовником",
        "job_offer": "Job offer",
        "test_task": "Тестове завдання",
        "security_check": "Перевірка безпеки",
        "tech_screen": "Тех. скринінг",
        "sent_offer": "Відправлений offer",
        "accept_offer": "Прийнятий offer",
        "invite_to_interview": "Запрошення на інтерв'ю",
        "interview_scheduled": "Інтерв'ю заплановано",
        "interview_conducted": "Інтерв'ю проведено",
        "rejected": "Відвергнуто",
        "no_response": "Не відповідає",
        "no_contacts": "Немає контактів",
        "accepted_counter_offer": "Прийняв контроффер",
        "found_another_job": "Знайшов іншу роботу",
        "open": "Відкрита",
        "disqualified": "Відмова"
    },
}